import { useEffect, useRef, useState } from "react";

const formatNumber = (value) => Number(value || 0).toLocaleString("fa-IR");

function AnimatedNumber({ value = 0, duration = 850 }) {
  const target = Math.max(0, Number(value) || 0);
  const previousValue = useRef(0);
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    const startValue = previousValue.current;
    previousValue.current = target;

    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

    if (reduceMotion || startValue === target) {
      setDisplayValue(target);
      return undefined;
    }

    const requestFrame = window.requestAnimationFrame || ((callback) => window.setTimeout(() => callback(Date.now()), 16));
    const cancelFrame = window.cancelAnimationFrame || window.clearTimeout;
    let frameId;
    let startedAt;

    const animate = (timestamp) => {
      if (startedAt === undefined) startedAt = timestamp;
      const progress = Math.min((timestamp - startedAt) / duration, 1);
      const easedProgress = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(startValue + (target - startValue) * easedProgress));

      if (progress < 1) frameId = requestFrame(animate);
    };

    frameId = requestFrame(animate);
    return () => cancelFrame(frameId);
  }, [duration, target]);

  return (
    <span className="service-performance__value" aria-label={formatNumber(target)}>
      {formatNumber(displayValue)}
    </span>
  );
}

export default AnimatedNumber;
